<template>
  <div class="cardPointData-index">
    <div class="marketing-search">
      <el-row :class="`form-row`" :gutter="0">
        <div class="col-left">
          <el-form ref="form" :model="form" label-width="100px">
            <el-row :gutter="16" class="form-item-row" z>
              <el-col :span="8" v-if="form.type=='month'">
                <el-form-item label="月份" prop="monthList">
                  <el-date-picker
                    key="monthList"
                    type="months"
                    format="yyyy-MM"
                    v-model="form.monthList"
                    placeholder="请选择月份">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8"  v-if="form.type=='month'&&form.monthList&&form.monthList.length!=0">
                <el-form-item label="日期" prop="datesTime">
                  <el-date-picker
                    popper-class="due_dates"
                    key="dayList"
                    type="dates"
                    format="dd"
                    v-model="form.dayList"
                    placeholder="请选择日期"
                     @focus="timeEditable"
                    >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8"  v-if="form.type=='day'">
                <el-form-item label="日期" prop="dateTimeAll">
                  <el-date-picker
                    key="dateTimeAll"
                    v-model="form.dateTimeAll"
                    type="daterange"
                    range-separator=""
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="类型" prop="platform">
                  <el-select
                    clearable
                    collapse-tags
                    filterable
                    v-model="form.type"
                    @change="onTypeChange"
                    placeholder="请选择类型"
                  >
                    <el-option
                      v-for="(optionItem, optionIndex) in option"
                      :key="optionIndex"
                      :label="optionItem.label "
                      :value="optionItem.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            <el-col :span="8" v-if="(form.type=='month'&& (!form.monthList) || (form.monthList&&form.monthList.length==0)) || form.type=='day'">
                <el-button type="primary" class="mr10" @click="onSearch(form)">查询</el-button>
                <el-button  @click="resetForm('form')">重置</el-button>
                <el-button  @click="onExport" :loading="exportLoading" >导出</el-button>
            </el-col>
            </el-row>
          </el-form>
        </div>
      </el-row>
      <div
        class="button-div"
        style="padding-left: 100px;"
        v-if="form.type=='month'&&form.monthList&&form.monthList.length!=0"
      >
      <el-button type="primary" class="mr10" @click="onSearch(form)">查询</el-button>
      <el-button class @click="resetForm('form')">重置</el-button>
      <el-button @click="onExport" :loading="exportLoading">导出</el-button>
      </div>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      :emptyText="emptyText"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #dateStr="{ row }">{{ row.dateStr }}</template>
      <template #point="{ row }">{{ row.point ? String(row.point) :'0'}}</template>
      <template #num="{ row }">{{ row.num ? String(row.num) :'0'}}</template>
      <template #dayNum="{ row }">{{ row.dayNum ? String(row.dayNum) :'0' }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from "@/components/AuthButton";
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import {api_getMemberSaleDataPointList, api_getMemberSaleDataPointExport} from "@/api/member";
import { downFile } from "@/utils";
import tableList from "@/mixins/tableList";
export default {
  name: "cardPointData",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table
  },
  data() {
    return {
      renderData: [],
      form: {
        type:'month',
      },
      emptyText:'暂无数据',
      option: [
        {
          value: "month",
          label: "月维度"
        },
        {
          value: "day",
          label: "日维度"
        }
      ],
      tableThData: [
        { prop: "dateStr", label: "日期", minWidth: "120" },
        { prop: "dayNum", label: "办卡量", minWidth: "120" },
        { prop: "num", label: "积分笔数", minWidth: "120" },
        { prop: "point", label: "积分总数", minWidth: "120" },
      ],
      exportLoading: false
    };
  },
  created() {},
  methods: {
    // 点击导出
    async onExport() {
      this.exportLoading = true;
      const params = {
        ...this.form,
      };
    let isGetList = false
    switch (params.type) {
      case 'month':
        if (params.monthList&&params.monthList.length!=0) {
          isGetList = true 
          params.monthList = params.monthList.map(item=>{
            item = this.$moment(item).format('YYYY-MM')
            console.log(item)
            return item
          })
          if (params.dayList&&params.dayList.length!=0) {
            params.dayList = params.dayList.map(item=>{
            item = this.$moment(item).format('DD') 
             console.log(item)
            return item
          })
          }else{
            let dataList = []
            for (let index = 1; index <= 31; index++) {
              let data = index<10?`0${index}`:String(index)
              dataList.push(data)
            }
            params.dayList = dataList
          }
         delete params.dateTimeAll
        }
        break;
      case 'day':
        if(params.dateTimeAll&&params.dateTimeAll.length!=0){
           let timeNumber = 186 * 24 * 3600 * 1000;
          if ((params.dateTimeAll[1]-params.dateTimeAll[0]) >= timeNumber) {
              this.$baseMessage('日期跨度不能超过半年', 'error')
              this.exportLoading = false;
              return 
          }
          isGetList = true 
          params.start = this.$moment(params.dateTimeAll[0]).format('YYYY-MM-DD')
          params.end = this.$moment(params.dateTimeAll[1]).format('YYYY-MM-DD')
          delete params.dateTimeAll
          delete params.dayList
          delete params.monthList
        }
        break;
     }
     if (isGetList) {
      try {
      const res = await api_getMemberSaleDataPointExport(params);
        downFile(res);
        this.exportLoading = false;
      } catch (error) {
        console.log(error)
        this.exportLoading = false;
      }
     }else{
       this.$baseMessage('请选择需要导出的数据', 'error')
       this.exportLoading = false;
     }
    },
    // 获取表格列表数据
    async getList() {
      this.loading = true;
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit
      };
    let isGetList = false
    switch (params.type) {
      case 'month':
        if (params.monthList&&params.monthList.length!=0) {
          isGetList = true 
          params.monthList = params.monthList.map(item=>{
            item = this.$moment(item).format('YYYY-MM')
            console.log(item)
            return item
          })
          if (params.dayList&&params.dayList.length!=0) {
            params.dayList = params.dayList.map(item=>{
            item = this.$moment(item).format('DD') 
             console.log(item)
            return item
          })
          }else{
            let dataList = []
            for (let index = 1; index <= 31; index++) {
              let data = index<10?`0${index}`:String(index)
              dataList.push(data)
            }
            params.dayList = dataList
          }
         delete params.dateTimeAll
        }
        break;
      case 'day':
        if(params.dateTimeAll&&params.dateTimeAll.length!=0){
           let timeNumber = 186 * 24 * 3600 * 1000;
           if ((params.dateTimeAll[1]-params.dateTimeAll[0]) >= timeNumber) {
              this.$baseMessage('日期跨度不能超过半年', 'error')
              this.loading = false;
              return 
          }
          isGetList = true 
          params.start = this.$moment(params.dateTimeAll[0]).format('YYYY-MM-DD')
          params.end = this.$moment(params.dateTimeAll[1]).format('YYYY-MM-DD')
          delete params.dateTimeAll
          delete params.dayList
          delete params.monthList
        }
        break;
     }
     if (isGetList) {
      try {
      const data = await api_getMemberSaleDataPointList(params);
      this.tableTrData = data.list || [];
      this.total = data.count;
      this.loading = false;
      data.list.length == 0 ? this.emptyText = '暂无数据':''
      } catch (error) {
        this.loading = false;
        this.emptyText = '暂无数据'
      }
     }else{
      this.tableTrData = [];
      this.total = 0;
      this.loading = false;
      this.emptyText = '请选择需要查询的数据'
     }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.form = {
        type:'month'
      }
    },
    timeEditable() {
      this.$nextTick(() => {
        let els = document.querySelectorAll(
          '.el-date-picker__header'
        )
        for (var i = 0; i <= els.length - 1; i++) {
          els[i].style.display = 'none'
        }
      })
    },
     onTypeChange(item){
      switch (item) {
        case 'month':
          this.$refs.form.resetFields()
          this.form = {
            type:'month'
          }
          break;
        case 'day':
          this.$refs.form.resetFields()
          this.form = {
            type:'day'
          }
          break;
        default:
          break;
      }
    }
  },
  computed: {},
  watch: {
    form: {
      deep: true,
      handler(newVal, oldVal) {
        this.form = newVal
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.marketing-search{
  // min-height: 186px;
  background-color: #fff;
  border-bottom: 1px solid #cccccc80;
  box-sizing: border-box;
  margin-top: 25px;

  .form-row {
    // height: 64px;
    overflow: hidden;
    display: flex;
    .el-cascader,
    .el-input,
    .el-select,
    .el-input__inner {
      width: 100% !important;
      max-width: 400px;
    }
  }

  .ml80 {
    margin-left: 80px;
  }

  ::v-deep {
    .el-form{
      label{
        font-size: 14px;
      }
      .form-item-row{
        // max-width: calc(100% - 142px);
        display: flex;
        flex-wrap: wrap;
        align-content: space-evenly;
        // justify-content: space-between;
        // min-height: 186px;

        .el-col {
          margin: 10px 0;
          height: 34px;

          &.width0 {
            width: 0;
            padding: 0 !important;
            overflow: hidden;
          }
        }
      }
      .el-form-item{
        margin-bottom: 0;

        .el-form-item__label,
        .el-form-item__content {
          line-height: 34px;

          .el-input__suffix-inner {
            i {
              line-height: 34px;
            }
          }
        }
      }
      .el-select{
        display: block;
      }
      .el-range-editor.el-input__inner{
        width: auto;
        background: #F2F3F5;
        border: 0;
        input{
          background: #F2F3F5;
          border: 0;
        }
      }
      .el-range-editor.el-input__inner.is-active{
        width: auto;
        background: #fff;
        border: 1px solid #05C8AF;
        input{
          background: #fff;
          border: 0;
        }
      }
      .el-input{
        border-radius: 2px;
        font-size: 14px;
        .el-input__inner{
          background: #F2F3F5;
          border: 0;
          height: 34px;
        }
        .el-input__inner:focus{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
      .el-input.is-focus+.el-cascader__tags{
        input{
          background: #fff;
        }
      }

      .el-cascader{
        .el-input{
          input{
            height: 34px !important;
          }
        }
      }
      .el-input.is-focus{
        .el-input__inner{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
    }
  }

  .form-btn-col {
    display: flex;
    .el-button {
      min-width: 80px !important;
    }
  }
  .button-div{
    height: 34px;
    margin: 10px 0 30px 0;
    overflow: hidden;
    opacity: 1;

    &.height0 {
      height: 0;
      opacity: 0;
      margin: 0;
    }

    .el-button {
      min-width: 80px !important;
    }
  }

  .col-left {
    flex: 1;
  }

  .col-right {
    // width: 300px;
    // background-color: #ccc;
    overflow: hidden;
    height: 34px;
    text-align: right;
    margin: 10px 0;

    .el-button {
      min-width: auto;
      padding: 0 24px;
      margin-right: 0;
      margin-left: 10px;
    }
  }
  .more-btn {
    font-size: 14px;
    padding: 0 !important;
    min-width: auto !important;
    margin-left: 20px !important;

    i {
      margin-left: 10px;
      font-size: 14px;
    }
  }
}
</style>
